import React from 'react'
import { auth } from 'firebase';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

const uiConfig = {
  signInFlow: 'popup',
  signInSuccessUrl: '/',
  signInOptions: [
    auth.GoogleAuthProvider.PROVIDER_ID
  ]
};

const SignedOutLinks = () => {
  return (
    <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={auth()}/>
  )
}

export default SignedOutLinks


// WEBPACK FOOTER //
// ./src/components/navbar/SignedOutLinks.js